<div [formGroup]="enterActualForm" *ngIf="!loadingRecords">
    <section class="workflow-input-group">
        <div class="workflow-section-heading">Enter Staffing Levels</div>
        <ng-template [ngIf]="hasVariableJobsByShiftBlockId()">
            <div class="warning notification" *ngFor="let varianceWarning of getVarianceWarnings()">
                <span class="icon-notification"></span> {{ varianceWarning }}
            </div>
            <div class="workflow-section-subheading">Enter Variable Hours <span class="hours-calculator-link" >
                &nbsp;&nbsp;&nbsp;                               
                <a  (click)="openHoursCalculator()"> 
                <svg class="calculator-icon"> <use xlink:href="assets/symbol-defs.svg#icon-calculator"></use>  </svg>  
                Hours Calculator</a>
                </span>                 
            </div>
            <smt-hours-calculator 
                (acceptEvent)="showHoursWarning($event)"
                [(shiftRecord)]="shiftRecord" 
                (rejectEvent)="closeCalculatorModal($event)"
                [(completedRows)] ="staffWarningRows"
                [(targetStaffs)]="targetStaffs"
                *ngIf="showHoursCalculatorModal">
            </smt-hours-calculator>
            <div class="workflow-input-labels">
                <span>Target</span>
                <span>Planned</span>
                <span>Actual</span>
            </div>
            <div class="workflow-input" *ngFor="let varStaff of getVariableJobTitles()">
                <input type="text" [formControlName]="getTargetControlName(varStaff.id)" id="{{ getTargetControlName(varStaff.id) }}">
                <input type="text" [formControlName]="getPlannedControlName(varStaff.id)" id="{{ getPlannedControlName(varStaff.id) }}">
                <input type="number" min="{{ minValue }} " max="{{ maxValue }}" [formControlName]="getActualControlName(varStaff.id)" id="{{ getActualControlName(varStaff.id) }}">
                <span class="display-label">{{ varStaff.abbreviation }}
                    <ng-container *ngIf="showStaffWarning()">
                        <span class="warning notification"  >
                            <span class="icon-notification"></span>  {{ getStaffWarning(varStaff.id) }}
                        </span>
                    </ng-container>
                </span>
            </div>
        </ng-template>                    
        <ng-template [ngIf]="hasFixedJobs()">
            <a class="workflow-section-link" (click)="toggleFixedStaff()">Enter Fixed Staff</a>  
            &nbsp;
            <button class="compact" (click)="toggleFixedJobEditing()"><span class="icon-pencil"></span> Edit</button>
            <ng-template [ngIf]="showFixedStaff">  
                <div class="workflow-input-labels">
                    <span>Target</span>
                    <span>Planned</span>
                    <span>Actual</span>
                </div>
                <div class="workflow-input" *ngFor="let fixed of getFixedJobTitles()">
                    <input type="text" [formControlName]="getTargetControlName(fixed.id)" id="{{ getTargetControlName(fixed.id) }}">
                    <input type="text" [formControlName]="getPlannedControlName(fixed.id)" id="{{ getPlannedControlName(fixed.id) }}">
                    <input type="number" min="{{ minValue }} " max="{{ maxValue }}" [formControlName]="getActualControlName(fixed.id)" id="{{ getActualControlName(fixed.id) }}">
                    <span class="display-label">{{ fixed.abbreviation }}</span>
                </div>
            </ng-template>
        </ng-template>
        <ng-template [ngIf]="!hasJobs()">
            <div class="no-previous-block">The staffing plan for this shift block was not completed on this day.</div>
        </ng-template>
        <div class="warning info" *ngIf="enterByBlock && showPlannedWarning()">* The information recorded during the previous block is incomplete.  Please complete your missing shift block.</div>
        <div class="warning info" *ngIf="!enterByBlock && showPlannedWarning()">* The information recorded during the previous working day is incomplete.  Please complete your missing shift block.</div>
    </section>
</div>
